import script from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"

import "./UnitModal.vue?vue&type=style&index=0&id=228f902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ba72acede7d185cd4b845efdf6705c95/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228f902c"]])

export default __exports__